import { render, staticRenderFns } from "./indexCode.vue?vue&type=template&id=fa1ab752&scoped=true"
import script from "./indexCode.vue?vue&type=script&lang=js"
export * from "./indexCode.vue?vue&type=script&lang=js"
import style0 from "./indexCode.vue?vue&type=style&index=0&id=fa1ab752&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1ab752",
  null
  
)

export default component.exports